import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { APIProvider } from "@vis.gl/react-google-maps";
import { router } from "./router";
import { configApi } from "./lib/api/client";

// Fetch the browser Maps key once before the first render so the Places library is available app-wide
// without a remount. If config is unavailable, the app still renders and address inputs degrade to
// plain text fields.
async function bootstrap() {
  let mapsKey = "";
  try {
    mapsKey = (await configApi.get()).googleMapsApiKey ?? "";
  } catch {
    /* degrade: render without Maps */
  }

  const app = <RouterProvider router={router} />;

  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      {mapsKey ? <APIProvider apiKey={mapsKey} libraries={["places"]}>{app}</APIProvider> : app}
    </React.StrictMode>,
  );
}

void bootstrap();
